import httpClient from "./httpClient";

const END_POINT = "/api/prolongations";
const addProlongation = prolongation =>
  httpClient.post('/api/addProlongations', prolongation);
const getAllProlongations = (page, filterList, perPage) =>
  httpClient.post(`${END_POINT}?page=${page}&per_page=${perPage}`, filterList);
export { addProlongation, getAllProlongations };
